import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import Footer from "./Footer";
import TrialCountdownBanner from "./TrialCountdownBanner";

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Close sidebar when route changes
  useEffect(() => {
    setSidebarOpen(false);
  }, [location]);

  // Prevent body scroll when mobile sidebar is open
  useEffect(() => {
    if (sidebarOpen && window.innerWidth < 1024) {
      // Only prevent scroll on the main content, not the sidebar itself
      const mainContent = document.querySelector('main');
      if (mainContent) {
        mainContent.style.overflow = 'hidden';
      }
    } else {
      const mainContent = document.querySelector('main');
      if (mainContent) {
        mainContent.style.overflow = 'unset';
      }
    }

    return () => {
      const mainContent = document.querySelector('main');
      if (mainContent) {
        mainContent.style.overflow = 'unset';
      }
    };
  }, [sidebarOpen]);

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const toggleSidebar = () => {
    const newState = !sidebarOpen;
    setSidebarOpen(newState);
    
    // If opening sidebar on mobile, scroll to top smoothly
    if (newState && window.innerWidth < 1024) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <TopBar onToggleSidebar={toggleSidebar} />
      <div className={`${sidebarOpen ? 'flex-col' : 'flex'} flex-1`}>
        {/* Mobile sidebar overlay - only visible when sidebar is open on mobile */}
        {sidebarOpen && (
          <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30" onClick={closeSidebar} />
        )}
        
        {/* Sidebar is always visible on lg+, toggled on mobile */}
        <div
          className={`${
            sidebarOpen ? "opacity-100 visible translate-x-0" : "opacity-0 invisible -translate-x-full"
          } lg:block lg:opacity-100 lg:visible lg:translate-x-0 w-80 lg:w-64 bg-kci-100 border-r lg:sticky lg:top-0 lg:relative fixed top-16 left-0 z-50 transition-all duration-300 ease-in-out lg:transition-none lg:shadow-none shadow-2xl lg:rounded-none rounded-r-lg`}
          style={{ 
            maxHeight: 'calc(100vh - 64px)',
            height: 'calc(100vh - 64px)',
            overflowY: 'auto',
            minHeight: 'calc(100vh - 64px)',
            // Ensure scrolling works on mobile WebKit browsers
            WebkitOverflowScrolling: 'touch'
          }}
        >
          <Sidebar onNavigate={closeSidebar} />
        </div>

        <main className={`${sidebarOpen ? 'w-full' : 'flex-1'} p-4 flex flex-col`}>
          <TrialCountdownBanner />
          <div className="flex-1">
            <Outlet />
          </div>
          <div className="flex-shrink-0 mt-4">
            <Footer />
          </div>
        </main>
      </div>
    </div>
  );
}
